export const config = {
  isTopCache: false,
  isAppSim: false,
  isSinglePageApp: false,
};

let _currentScreen_: 'main' | 'sub' = 'main';
export function setCurrentScreen(screen: 'main' | 'sub') {
  _currentScreen_ = screen;
}
export function getCurrentScreen() {
  return _currentScreen_;
}
